// @ts-nocheck
/* eslint-disable */
var SelectingTimes = /*#__PURE__*/function (SelectingTimes) {
  SelectingTimes[SelectingTimes["Hour"] = 1] = "Hour";
  SelectingTimes[SelectingTimes["Minute"] = 2] = "Minute";
  SelectingTimes[SelectingTimes["Second"] = 3] = "Second";
  return SelectingTimes;
}(SelectingTimes || {});
export { SelectingTimes };
//# sourceMappingURL=SelectingTimes.mjs.map